import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  inject,
  signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UIRouterModule } from '@uirouter/angular';
import { StateService } from '@uirouter/core';

import { CompanyTreeComponent } from 'src/app/app-common/components/company-tree/company-tree.component';
import { CompanyTreeService } from 'src/app/app-common/services/company-tree.service';
import { ComponentsModule } from 'src/app/components/components.module';
import { FeaturesService } from 'src/app/components/plans/features.service';
import { CompanyAccessService } from 'src/app/settings/services/company-access.service';

@Component({
  selector: 'select-company-tree',
  templateUrl: './select-company-tree.component.html',
  styleUrl: './select-company-tree.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ComponentsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    UIRouterModule,
    CompanyTreeComponent,
  ],
  providers: [CompanyTreeService],
})
export class SelectCompanyTreeComponent {
  @Output() closeMenu = new EventEmitter<void>();

  private readonly featuresService = inject(FeaturesService);
  private readonly stateService = inject(StateService);
  protected readonly companyAccessService = inject(CompanyAccessService);
  protected readonly treeService = inject(CompanyTreeService);

  protected readonly mode = signal<'tree' | 'search'>('tree');

  protected readonly filterConfig = {
    placeholder: 'Search Sub-Company',
    borderless: true,
  };

  protected readonly search: { query: string } = { query: '' };

  constructor() {
    void this.treeService.initialize();
  }

  protected doSearch = (): void => {};

  protected licenseManagement(): void {
    if (this.companyAccessService.accessCompanyLicenses) {
      this.stateService.go('apps.settings.company-licenses');
      this.closeMenu.emit();
    } else {
      this.featuresService.showUpgradePlanModal(
        FeaturesService.FEATURE_LICENSE_MANAGEMENT,
      );
    }
  }
}
